/* ============================================================
   edj-judgeme-fetcher.js
   Fetcher client-side pour l'API Judge.me — design EDJ conservé.

   VAGUE 4 item 7 — REFACTOR
   Cause racine : le PUBLIC_TOKEN ne peut PAS faire /api/v1/reviews
   (restriction Judge.me). Mais il PEUT faire
   /api/v1/widgets/product_review?handle=<HANDLE> qui retourne le HTML
   widget Judge.me complet avec data-attributes et chaque .jdgm-rev.
   On parse le HTML retourné via DOMParser et on reconstruit nos cartes
   EDJ via createElement + textContent (zéro innerHTML user-data).

   Sécurité : aucune chaîne HTML construite par concaténation avec
   des données utilisateur. Toutes les valeurs venant de l'API sont
   posées via element.textContent (jamais innerHTML), pour éviter
   tout risque XSS si l'API ou le shop renvoyait du HTML brut.

   - Lit data-product-handle, data-judgeme-token, data-judgeme-shop sur la section
   - Fetch /api/v1/widgets/product_review?handle=<HANDLE>&api_token=<PUBLIC>&shop_domain=<SHOP>
   - Parse le widget HTML via DOMParser (jdgm-rev-widg + jdgm-rev)
   - Render dans la même structure DOM que les blocks Liquid (.product-reviews__card)
   - Fallback gracieux : si erreur ou empty, on garde l'empty state Liquid
   - Met à jour la note moyenne, le nombre total, la répartition (breakdown)

   Lot 3 — Wave Judge.me (items 7+23) — refactor VAGUE 4 item 7
   ============================================================ */

(function () {
  'use strict';

  var API_BASE = 'https://judge.me/api/v1';
  var DEFAULT_PER_PAGE = 10;

  /* ────────────────────────────────────────────────────────────
     Utils
     ──────────────────────────────────────────────────────────── */

  function formatDateFR(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      var months = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
      ];
      return months[d.getMonth()] + ' ' + d.getFullYear();
    } catch (e) {
      return '';
    }
  }

  function getInitial(name) {
    if (!name) return '?';
    var trimmed = String(name).trim();
    if (!trimmed) return '?';
    return trimmed.charAt(0).toUpperCase();
  }

  function clampRating(r) {
    var n = parseInt(r, 10);
    if (isNaN(n)) return 5;
    if (n < 1) return 1;
    if (n > 5) return 5;
    return n;
  }

  function el(tag, opts) {
    var node = document.createElement(tag);
    if (!opts) return node;
    if (opts.className) node.className = opts.className;
    if (opts.text != null) node.textContent = opts.text;
    if (opts.attrs) {
      Object.keys(opts.attrs).forEach(function (k) {
        node.setAttribute(k, opts.attrs[k]);
      });
    }
    if (opts.dataset) {
      Object.keys(opts.dataset).forEach(function (k) {
        node.dataset[k] = opts.dataset[k];
      });
    }
    return node;
  }

  /* ────────────────────────────────────────────────────────────
     Build URL & fetch — endpoint widgets/product_review
     ──────────────────────────────────────────────────────────── */

  function buildWidgetUrl(token, shop, handle) {
    var params = new URLSearchParams({
      api_token: token,
      shop_domain: shop,
      handle: String(handle)
    });
    return API_BASE + '/widgets/product_review?' + params.toString();
  }

  function fetchWidget(token, shop, handle) {
    return fetch(buildWidgetUrl(token, shop, handle), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'omit'
    }).then(function (res) {
      if (!res.ok) throw new Error('Judge.me HTTP ' + res.status);
      return res.json();
    });
  }

  /* ────────────────────────────────────────────────────────────
     Parser : transforme le HTML widget Judge.me en données structurées.
     Réponse API : { product_external_id, widget: "<div class='jdgm-rev-widg' ...>...</div>" }
     ──────────────────────────────────────────────────────────── */

  function parseWidgetHtml(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var widget = doc.querySelector('.jdgm-rev-widg');
    if (!widget) {
      return { avg: 0, count: 0, reviews: [] };
    }
    var avg = parseFloat(widget.getAttribute('data-average-rating')) || 0;
    var count = parseInt(widget.getAttribute('data-number-of-reviews'), 10) || 0;

    var reviews = [];
    var nodes = widget.querySelectorAll('.jdgm-rev');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      // Rating : .jdgm-rev__rating[data-score] OU compter les .jdgm--on
      var rating = 0;
      var ratingEl = node.querySelector('.jdgm-rev__rating');
      if (ratingEl) {
        var score = ratingEl.getAttribute('data-score');
        if (score) rating = parseInt(score, 10);
      }
      if (!rating) {
        // Fallback : compter les étoiles pleines
        var stars = node.querySelectorAll('.jdgm-rev__rating .jdgm--on, .jdgm-star.jdgm--on');
        rating = stars.length || 0;
      }

      var titleEl = node.querySelector('.jdgm-rev__title');
      var bodyEl = node.querySelector('.jdgm-rev__body');
      var authorEl = node.querySelector('.jdgm-rev__author');
      var timestampEl = node.querySelector('.jdgm-rev__timestamp');
      var verifiedEl = node.querySelector('.jdgm-rev__buyer-badge--verified, .jdgm-rev__buyer-badge.jdgm-rev__buyer-badge--verified');

      // Date : data-content (ISO) ou textContent
      var createdAt = '';
      if (timestampEl) {
        createdAt = timestampEl.getAttribute('data-content') || timestampEl.textContent || '';
      }

      // Photos : .jdgm-rev__pic img ou .jdgm-rev__pic-img background-image
      var pictures = [];
      var picNodes = node.querySelectorAll('.jdgm-rev__pic, .jdgm-rev__pic-img, .jdgm-rev__pic-link');
      for (var p = 0; p < picNodes.length; p++) {
        var pic = picNodes[p];
        var url = '';
        var img = pic.tagName === 'IMG' ? pic : pic.querySelector('img');
        if (img && img.getAttribute('src')) {
          url = img.getAttribute('src');
        } else if (pic.getAttribute('href')) {
          url = pic.getAttribute('href');
        } else {
          // Tenter background-image inline
          var bg = pic.style && pic.style.backgroundImage;
          if (bg) {
            var m = bg.match(/url\(['"]?([^'")]+)['"]?\)/);
            if (m) url = m[1];
          }
        }
        if (url && /^https?:\/\//.test(url)) {
          pictures.push({ urls: { original: url } });
        }
      }

      reviews.push({
        rating: clampRating(rating),
        title: titleEl ? titleEl.textContent.trim() : '',
        body: bodyEl ? bodyEl.textContent.trim() : '',
        reviewer: { name: authorEl ? authorEl.textContent.trim() : '' },
        created_at: createdAt,
        verified: !!verifiedEl,
        pictures: pictures
      });
    }

    return { avg: avg, count: count, reviews: reviews };
  }

  /* ────────────────────────────────────────────────────────────
     DOM builders — pas de string interpolation pour les valeurs API.
     Shape interne après parseWidgetHtml() :
       {
         avg: Number,           // moyenne extraite de data-average-rating
         count: Number,         // total reviews depuis data-number-of-reviews
         reviews: [
           { rating, title, body, reviewer:{name}, created_at,
             verified, pictures: [{urls:{original}}] }
         ]
       }
     ──────────────────────────────────────────────────────────── */

  function buildStars(rating, sizeMd) {
    var sizeClass = sizeMd ? 'product-reviews__stars--md' : 'product-reviews__stars--sm';
    var wrap = el('div', {
      className: 'product-reviews__stars ' + sizeClass,
      attrs: { role: 'img', 'aria-label': 'Note ' + rating + ' sur 5' }
    });
    for (var i = 1; i <= 5; i++) {
      var filled = i <= rating;
      var star = el('span', {
        className: filled
          ? 'product-reviews__star product-reviews__star--filled'
          : 'product-reviews__star',
        text: '★',
        attrs: { 'aria-hidden': 'true' }
      });
      wrap.appendChild(star);
    }
    return wrap;
  }

  function buildVerifiedBadge() {
    var span = el('span', { className: 'product-reviews__verified' });
    span.appendChild(el('span', {
      className: 'product-reviews__verified--desktop',
      text: '✓ Vérifié'
    }));
    span.appendChild(el('span', {
      className: 'product-reviews__verified--mobile',
      text: '✓ Achat vérifié'
    }));
    return span;
  }

  /* Photo principale en colonne dédiée (96×96 desktop, pleine largeur mobile).
     S'il y a plusieurs photos, on met un badge "+N" sur la principale.
     Les URL HTTP(S) sont posées via style.backgroundImage (jamais innerHTML). */
  function buildPhotoMedia(pictures) {
    var wrap = el('div', {
      className: 'product-reviews__card-media',
      attrs: { 'aria-label': 'Photo client' }
    });
    var first = pictures[0];
    var url = '';
    if (first && first.urls) {
      url = first.urls.original || first.urls.huge || first.urls.compact || first.urls.small || '';
    } else if (typeof first === 'string') {
      url = first;
    }
    if (url && /^https?:\/\//.test(url)) {
      wrap.style.backgroundImage = 'url(' + JSON.stringify(url) + ')';
      wrap.style.backgroundSize = 'cover';
      wrap.style.backgroundPosition = 'center';
    } else {
      wrap.textContent = '📷';
    }
    if (pictures.length > 1) {
      var badge = el('span', {
        className: 'product-reviews__card-media-more',
        text: '+' + (pictures.length - 1),
        attrs: { 'aria-label': pictures.length + ' photos client' }
      });
      wrap.appendChild(badge);
    }
    return wrap;
  }

  function buildReviewCard(review, index) {
    var rating = clampRating(review.rating);
    var author = (review.reviewer && review.reviewer.name) || review.name || 'Anonyme';
    var initial = getInitial(author);
    var date = formatDateFR(review.created_at);
    var body = (review.body || '').trim();
    var title = (review.title || '').trim();
    var verified = review.verified === true
      || review.verified === 'verified-buyer'
      || review.verified === 'buyer'
      || review.curated === 'ok';
    var hasPhotos = Array.isArray(review.pictures) && review.pictures.length > 0;

    var card = el('article', {
      className: hasPhotos
        ? 'product-reviews__card product-reviews__card--with-photo'
        : 'product-reviews__card',
      dataset: {
        reviewIndex: String(index),
        reviewRating: String(rating),
        reviewHasPhotos: hasPhotos ? '1' : '0',
        reviewVerified: verified ? '1' : '0'
      }
    });

    /* photo column (left on desktop, top on mobile) */
    if (hasPhotos) {
      card.appendChild(buildPhotoMedia(review.pictures));
    }

    /* content column wrapper (group head + body in the right column on desktop) */
    var content = el('div', { className: 'product-reviews__card-content' });

    /* head */
    var head = el('header', { className: 'product-reviews__card-head' });
    var authorWrap = el('div', { className: 'product-reviews__author' });
    authorWrap.appendChild(el('div', {
      className: 'product-reviews__avatar',
      text: initial,
      attrs: { 'aria-hidden': 'true' }
    }));
    var meta = el('div', { className: 'product-reviews__author-meta' });
    var nameLine = el('div', { className: 'product-reviews__author-name' });
    nameLine.appendChild(document.createTextNode(author));
    if (verified) nameLine.appendChild(buildVerifiedBadge());
    meta.appendChild(nameLine);
    meta.appendChild(el('div', {
      className: 'product-reviews__author-sub',
      text: date
    }));
    authorWrap.appendChild(meta);
    head.appendChild(authorWrap);
    head.appendChild(buildStars(rating, false));
    content.appendChild(head);

    /* body */
    var p = el('p', { className: 'product-reviews__body' });
    if (title) {
      var strong = el('strong', { text: title });
      p.appendChild(strong);
      p.appendChild(document.createTextNode(' — « ' + body + ' »'));
    } else {
      p.textContent = '« ' + body + ' »';
    }
    content.appendChild(p);

    card.appendChild(content);
    return card;
  }

  /* ────────────────────────────────────────────────────────────
     Stats
     ──────────────────────────────────────────────────────────── */

  function computeStatsFromReviews(reviews) {
    var total = reviews.length;
    var sum = 0;
    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    for (var i = 0; i < reviews.length; i++) {
      var r = clampRating(reviews[i].rating);
      sum += r;
      counts[r] = (counts[r] || 0) + 1;
    }
    var avg = total > 0 ? (sum / total) : 0;
    return { total: total, avg: avg, counts: counts };
  }

  /* ────────────────────────────────────────────────────────────
     Rating header buy-box — sync avec les vraies données Judge.me.
     Cherche [data-edj-rating] (snippet product-buy-box.liquid) et met à
     jour : data-edj-rating-state, aria-label, valeur texte, count, et
     largeur de l'overlay étoiles pleines (en % = avg/5 * 100).
     Si numReviews === 0 : on retombe sur l'état "empty" (—, 0 avis, 0%).
     ──────────────────────────────────────────────────────────── */
  function updateBuyBoxRating(avgRating, numReviews) {
    var ratingEl = document.querySelector('[data-edj-rating]');
    if (!ratingEl) return;

    var valueEl = ratingEl.querySelector('[data-edj-rating-value]');
    var countEl = ratingEl.querySelector('[data-edj-rating-count]');
    var fillEl = ratingEl.querySelector('[data-edj-rating-stars-fill]');

    var n = parseInt(numReviews, 10) || 0;
    var avg = parseFloat(avgRating) || 0;

    if (n === 0) {
      // 0 avis OU toggle off → bloc rating reste caché (hidden au render Liquid)
      ratingEl.setAttribute('hidden', '');
      ratingEl.setAttribute('data-edj-rating-state', 'empty');
      ratingEl.setAttribute('aria-label', 'Aucun avis pour le moment');
      if (valueEl) valueEl.textContent = '—';
      if (countEl) countEl.textContent = '(0 avis)';
      if (fillEl) fillEl.style.width = '0%';
    } else {
      // ≥1 avis → on affiche
      ratingEl.removeAttribute('hidden');
      var pct = Math.max(0, Math.min(100, (avg / 5) * 100));
      var label = 'avis';
      ratingEl.setAttribute('data-edj-rating-state', 'loaded');
      ratingEl.setAttribute(
        'aria-label',
        'Note ' + avg.toFixed(1) + ' sur 5, ' + n + ' ' + label
      );
      if (valueEl) valueEl.textContent = avg.toFixed(1) + '/5';
      if (countEl) countEl.textContent = '(' + n + ' ' + label + ')';
      if (fillEl) fillEl.style.width = pct + '%';
    }
  }

  function updateSummaryUI(section, stats, totalFromAPI) {
    var avgEl = section.querySelector('.product-reviews__avg-number');
    if (avgEl && stats.total > 0) {
      avgEl.textContent = stats.avg.toFixed(1).replace('.', ',');
    }
    var totalEl = section.querySelector('.product-reviews__avg-meta');
    if (totalEl && totalFromAPI != null) {
      totalEl.textContent = 'basé sur ' + totalFromAPI + ' avis vérifiés';
    }
    var allPill = section.querySelector('.product-reviews__pill[data-filter="all"]');
    if (allPill && totalFromAPI != null) {
      allPill.textContent = 'Tous (' + totalFromAPI + ')';
    }
    var rows = section.querySelectorAll('.product-reviews__breakdown-row');
    rows.forEach(function (row) {
      var labelEl = row.querySelector('.product-reviews__breakdown-label');
      if (!labelEl) return;
      var rating = parseInt(labelEl.textContent.trim(), 10);
      if (isNaN(rating)) return;
      var cnt = stats.counts[rating] || 0;
      var pct = stats.total > 0 ? Math.round((cnt / stats.total) * 100) : 0;
      var fill = row.querySelector('.product-reviews__breakdown-fill');
      var cntEl = row.querySelector('.product-reviews__breakdown-count');
      if (fill) fill.style.width = pct + '%';
      if (cntEl) cntEl.textContent = String(cnt);
    });
  }

  /* ────────────────────────────────────────────────────────────
     Filters (data-driven)
     ──────────────────────────────────────────────────────────── */

  function applyFilter(grid, filter) {
    var cards = grid.querySelectorAll('.product-reviews__card');
    cards.forEach(function (card) {
      var keep = true;
      if (filter === 'all') {
        keep = true;
      } else if (filter === 'photos') {
        keep = card.dataset.reviewHasPhotos === '1';
      } else if (filter === 'verified') {
        keep = card.dataset.reviewVerified === '1';
      } else if (filter === 'recent') {
        keep = parseInt(card.dataset.reviewIndex || '999', 10) < 6;
      } else {
        var n = parseInt(filter, 10);
        if (!isNaN(n)) {
          keep = parseInt(card.dataset.reviewRating || '0', 10) === n;
        }
      }
      card.classList.toggle('is-filtered-out', !keep);
    });
  }

  function bindFilters(section) {
    var pills = section.querySelectorAll('.product-reviews__pill');
    var grid = section.querySelector('[data-reviews-grid]');
    if (!grid) return;
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');
        applyFilter(grid, pill.dataset.filter || 'all');
      });
    });
  }

  /* ────────────────────────────────────────────────────────────
     Load-more
     Avec l'endpoint /widgets/product_review, on récupère TOUTES les
     reviews de la page widget en un appel. Pas de pagination côté API
     accessible avec le PUBLIC_TOKEN. On masque simplement le bouton
     load-more si reviews.length <= perPage, sinon on affiche les n
     premières et on dévoile le reste au clic (slice côté client).
     ──────────────────────────────────────────────────────────── */

  function bindLoadMore(section, ctx) {
    var btn = section.querySelector('[data-load-more]');
    if (!btn) return;
    if (ctx.allReviews.length <= ctx.perPage) {
      btn.style.display = 'none';
      return;
    }
    var newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    newBtn.addEventListener('click', function () {
      var grid = section.querySelector('[data-reviews-grid]');
      if (!grid) return;
      var nextChunk = ctx.allReviews.slice(ctx.shown, ctx.shown + ctx.perPage);
      var frag = document.createDocumentFragment();
      for (var i = 0; i < nextChunk.length; i++) {
        frag.appendChild(buildReviewCard(nextChunk[i], ctx.shown + i));
      }
      grid.appendChild(frag);
      ctx.shown += nextChunk.length;
      if (ctx.shown >= ctx.allReviews.length) {
        newBtn.style.display = 'none';
      }
    });
  }

  /* ────────────────────────────────────────────────────────────
     Init section
     ──────────────────────────────────────────────────────────── */

  function initSection(section) {
    if (!section || section.dataset.judgemeInit === '1') return;
    section.dataset.judgemeInit = '1';

    var token = section.dataset.judgemeToken;
    var shop = section.dataset.judgemeShop;
    var handle = section.dataset.productHandle;
    var enabled = section.dataset.judgemeEnabled === '1';

    if (!enabled) return;

    if (!token || !shop || !handle) {
      console.warn('[edj-judgeme] manquant : token/shop/handle — fallback Liquid blocks conservé');
      return;
    }

    var perPage = parseInt(section.dataset.reviewsPerPage, 10) || DEFAULT_PER_PAGE;
    if (perPage < 4) perPage = DEFAULT_PER_PAGE;

    var ctx = {
      token: token,
      shop: shop,
      handle: handle,
      perPage: perPage,
      allReviews: [],
      shown: 0
    };

    // Item 23 : passer en loading pour indiquer fetch en cours
    section.dataset.edjReviewsState = 'loading';

    function showEmpty() {
      section.dataset.edjReviewsState = 'empty';
      var emptyEl = section.querySelector('[data-edj-reviews-empty]');
      if (emptyEl) emptyEl.hidden = false;
      var gridEl = section.querySelector('[data-reviews-grid]');
      if (gridEl) gridEl.hidden = true;
      var filtersEl = section.querySelector('.product-reviews__filters');
      if (filtersEl) filtersEl.hidden = true;
    }

    fetchWidget(ctx.token, ctx.shop, ctx.handle)
      .then(function (data) {
        if (!data || data.error || !data.widget) {
          console.warn('[edj-judgeme] widget vide ou erreur API :', data && data.error);
          updateBuyBoxRating(0, 0);
          showEmpty();
          return;
        }

        var parsed = parseWidgetHtml(data.widget);
        var reviews = parsed.reviews;
        var totalFromAPI = parsed.count;
        var avgFromAPI = parsed.avg;

        // Sync rating header buy-box (—/5 ou X.X/5 selon données réelles Judge.me)
        updateBuyBoxRating(avgFromAPI, totalFromAPI);

        // Mise à jour du header (note moyenne et count) même si reviews=[]
        // ↳ utile si Judge.me a une moyenne stockée mais que la page widget ne
        //   contient pas encore les .jdgm-rev (ex : reviews paginées par leur JS).
        var avgEl = section.querySelector('.product-reviews__avg-number');
        if (avgEl && totalFromAPI > 0) {
          avgEl.textContent = avgFromAPI.toFixed(1).replace('.', ',');
        }
        var avgMeta = section.querySelector('.product-reviews__avg-meta');
        if (avgMeta && totalFromAPI > 0) {
          avgMeta.textContent = 'basé sur ' + totalFromAPI + ' avis vérifiés';
        }

        if (totalFromAPI === 0 || reviews.length === 0) {
          // 0 avis confirmé → afficher l'empty state proprement (pas de fake data)
          showEmpty();
          return;
        }

        ctx.allReviews = reviews.slice();
        var grid = section.querySelector('[data-reviews-grid]');
        if (!grid) return;

        // Cache l'empty state si présent, montre la grille
        var empty = section.querySelector('[data-edj-reviews-empty]');
        if (empty) empty.hidden = true;
        grid.hidden = false;
        var filters = section.querySelector('.product-reviews__filters');
        if (filters) filters.hidden = false;

        // Vide la grille (blocks Liquid fallback) puis remplit avec les vrais avis Judge.me
        while (grid.firstChild) grid.removeChild(grid.firstChild);
        var firstChunk = reviews.slice(0, perPage);
        var frag = document.createDocumentFragment();
        for (var i = 0; i < firstChunk.length; i++) {
          frag.appendChild(buildReviewCard(firstChunk[i], i));
        }
        grid.appendChild(frag);
        ctx.shown = firstChunk.length;
        section.dataset.judgemeRendered = '1';
        section.dataset.edjReviewsState = 'loaded';

        var stats = computeStatsFromReviews(reviews);
        // Override avg avec la valeur officielle Judge.me si dispo
        if (totalFromAPI > 0) {
          stats.avg = avgFromAPI;
        }
        updateSummaryUI(section, stats, totalFromAPI);

        bindFilters(section);
        bindLoadMore(section, ctx);

        var loadBtn = section.querySelector('[data-load-more]');
        if (loadBtn) {
          if (ctx.allReviews.length > ctx.shown) {
            loadBtn.style.display = '';
            loadBtn.textContent = '';
            loadBtn.appendChild(document.createTextNode('Voir plus d\'avis '));
            loadBtn.appendChild(el('span', { text: '→', attrs: { 'aria-hidden': 'true' } }));
          } else {
            loadBtn.style.display = 'none';
          }
        }
      })
      .catch(function (err) {
        console.warn('[edj-judgeme] fetch failed, fallback Liquid blocks:', err);
        // En cas d'échec : retomber sur empty (l'empty state initial Liquid reste visible)
        section.dataset.edjReviewsState = 'empty';
        // Le rating header reste sur l'état "empty" initial (—/5, 0 avis) — pas de mise à jour nécessaire
      });
  }

  /* ────────────────────────────────────────────────────────────
     CSS injection — pour le filtre is-filtered-out
     ──────────────────────────────────────────────────────────── */

  function injectFilterStyle() {
    if (document.getElementById('edj-judgeme-filter-style')) return;
    var style = document.createElement('style');
    style.id = 'edj-judgeme-filter-style';
    style.textContent = '.product-reviews__card.is-filtered-out{display:none !important;}';
    document.head.appendChild(style);
  }

  /* ────────────────────────────────────────────────────────────
     Bootstrap
     ──────────────────────────────────────────────────────────── */

  function initAll() {
    injectFilterStyle();
    document.querySelectorAll('[data-edj-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-edj-reviews]');
    if (section) initSection(section);
  });
})();
